import type { SelectOption } from '../types'
import { compareSelectLabels } from './compareSelectLabels'

export function sortSelectOptions(
  options: readonly SelectOption[]
): SelectOption[] {
  return [...options].sort((left, right) =>
    compareSelectLabels(left.label, right.label)
  )
}
